import { all, takeLatest, put, call, fork } from "redux-saga/effects";
import { actions } from "./actions";
import { apiV2 } from "../../services/api";

const { textBlasts: textBlastsApi } = apiV2;

// Action sagas - async
function* submitBlastRequest() {
  yield takeLatest("SUBMIT_BLAST_FORM/REQUEST", function* ({ payload }) {
    try {
      yield call(textBlastsApi.send, payload);
      yield put(
        actions.submitBlastForm.success({
          message: "Message has been processed and it will be sent soon.",
        })
      );
    } catch (err) {
      yield put(
        actions.submitBlastForm.failure({
          message: `Unable to create message.`,
        })
      );
    }
  });
}

// Watcher sagas
export default function* rootSaga() {
  yield all([fork(submitBlastRequest)]);
}
